export default __webpack_public_path__ + "static/media/plumberService.72b44c3b.jpg";